import { FULL_SCREEN } from "@/components/viewer/ui/constants/float_bar.constants";
import store from "@/store";
import { isDTRuntime } from "./3rd-party-integration/utils/env";

export async function hideFullScreen(pdfUI = window.pdfui) {
    if (!isDTRuntime && !store.teamsAppStore.inTeamsApp) {
        return;
    }

    const floatBar = await pdfUI.getComponentByName('float-bar');
    if (!floatBar) return;
    const fullScreenComponent = await floatBar.getComponentByName(FULL_SCREEN);
    fullScreenComponent.hide();
    floatBar.element.style.width = '700px';

    // FIXME When create ContextMenu?
    // https://gitlab.foxitsoftware.com/foxit/phantom/cloud/phantompdf_online/-/blob/develop/foxitwebsdk/src/pdf-viewer/ui/tiny-pdf-ui/TinyViewerUI.js#L60-L62
    setTimeout(async () => {
        const pageContextmenuComponent = await pdfUI.getComponentByName('fv--page-contextmenu')
        if (pageContextmenuComponent) {
            const pageContextmenuFullScreen = pageContextmenuComponent.getComponentByName('fv--contextmenu-item-full-screen');
            const pageContextmenuFullScreenSeparator = pageContextmenuFullScreen.nextSiblings();
            pageContextmenuFullScreen.hide();
            pageContextmenuFullScreenSeparator.hide();
        }
    }, 500);

}
